import { vars } from "@common/styles";
import styled, { css } from "styled-components";

export const TeamMembersHeader = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: row;
  margin-top: 2.4rem;
`;

export const CirclesWrap = styled.div<{ color?: string }>`
  display: flex;
  flex-direction: row;
  position: relative;
  align-items: center;
  margin-right: 0.5rem;
`;

export const Circle = styled.div<{ color?: string }>`
  border-radius: 10rem;
  width: 1.2rem;
  height: 1.2rem;
  border: 2px solid ${vars.colors.grey100};
  ${(props) =>
    props.color &&
    css`
      background: ${props.color};
    `};
`;
